'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { createStore, Provider } from 'jotai';
import type { FC, PropsWithChildren } from 'react';
export const JotaiStoreProvider: FC<PropsWithChildren> = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [store] = useState(_temp);
  let t1;
  if ($[0] !== children || $[1] !== store) {
    t1 = <Provider store={store}>{children}</Provider>;
    $[0] = children;
    $[1] = store;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp() {
  return createStore();
}